export class AtributoEstiloSegmento {
	idEstiloSegmento: number;
    idAtributoEstiloSegmento: number;
	atributo: string;
	valor: string;

	constructor (atributo: string, valor: string) {
		this.atributo = atributo;
		this.valor = valor;
	}
}